import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BulkDocAddPayload } from '../models/review/bulk-doc-add-payload.model';
import { EmailFamilySdk } from '../sdks/email-family.sdk';

@Injectable({
	providedIn: 'root'
})
export class EmailFamilyCountManager {

	constructor(private emailFamilySdk: EmailFamilySdk) { }

	public GetExpandedEmailFamilyDocCount(body: BulkDocAddPayload): Observable<number> {
		return this.emailFamilySdk.getEmailFamilyDocCountByQuery(body);			
	}
}
